import { useEffect, useState } from 'react'
import Select from 'react-select'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import api from '../../../utils/api'
import SelectStyles from '../../../shared/Select/SelectStyle'
import Input from '../../../shared/components/form/input'
import Button from '../../../shared/components/Button/Button'

function ServiceOrderFilterModal({ filters, onChange, onClear, onClose }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [clientOptions, setClientOptions] = useState([])
    const [technicianOptions, setTechnicianOptions] = useState([])
    const [procedureOptions, setProcedureOptions] = useState([])

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    useEffect(() => {
        const headers = { Authorization: `Bearer ${JSON.parse(token)}` }
        Promise.all([
            api.get('/client/getall', { headers }),
            api.get('/user/technicians', { headers }),
            api.get('/procedure/getall', { headers }),
        ]).then(([clientRes, techRes, procedureRes]) => {
            setClientOptions(clientRes.data.clients || [])
            setTechnicianOptions((techRes.data.technicians || []).map(t => ({
                ...t,
                label: t.name,
                value: t._id,
            })))
            setProcedureOptions((procedureRes.data.procedures || []).map(p => ({
                ...p,
                label: p.name,
                value: p._id,
            })))
        })
    }, [token])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar ordens de serviço</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Status</span>
                        <div className="fm-status-row">
                            {[
                                { value: 'all',          label: 'Todas' },
                                { value: 'aberta',       label: 'Aberta' },
                                { value: 'em_andamento', label: 'Em andamento' },
                                { value: 'em_analise',   label: 'Em análise' },
                                { value: 'concluida',    label: 'Concluída' },
                            ].map(opt => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.status === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('status', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Cliente</span>
                        <Select
                            options={clientOptions}
                            onChange={(opt) => onChange('client', opt)}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={filters.client || null}
                            placeholder="Todos os clientes"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Técnico</span>
                        <Select
                            options={technicianOptions}
                            onChange={(opt) => onChange('technician', opt)}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={filters.technician || null}
                            placeholder="Todos os técnicos"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Procedimento</span>
                        <Select
                            options={procedureOptions}
                            onChange={(opt) => onChange('procedure', opt)}
                            styles={SelectStyles}
                            menuPortalTarget={document.body}
                            value={filters.procedure || null}
                            placeholder="Todos os procedimentos"
                            isClearable
                        />
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Período agendado</span>
                        <div className="so-filter-date-row">
                            <div className="so-filter-date-col">
                                <Input
                                    type="date"
                                    name="dateFrom"
                                    text="De"
                                    value={filters.dateFrom || ''}
                                    handleOnChange={(e) => onChange('dateFrom', e.target.value)}
                                />
                            </div>
                            <div className="so-filter-date-col">
                                <Input
                                    type="date"
                                    name="dateTo"
                                    text="Até"
                                    value={filters.dateTo || ''}
                                    handleOnChange={(e) => onChange('dateTo', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ServiceOrderFilterModal
